import { render, staticRenderFns } from "./ReportT106.vue?vue&type=template&id=09ecf82a"
import script from "./ReportT106.vue?vue&type=script&lang=js"
export * from "./ReportT106.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports